import { render } from "./Menu.vue?vue&type=template&id=2fac58ac"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=2fac58ac&lang=css"

import exportComponent from "/media/diego-oliveira/ssd/projetos/andamento-da-obra-blend-pituba/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__